export function abort(reason) {
    return { kind: "Abort", reason };
}
export function execute(payload) {
    return { kind: "Exec", payload };
}
export function isAborted(v) {
    return v.kind === "Abort";
}
export function isAbortable(v) {
    return v && Object.hasOwnProperty.call(v, "kind") && (v.kind === "Exec" || v.kind === "Abort");
}
export function isAbortedRequest(v) {
    return v && Object.hasOwnProperty.call(v, "payload") && v.payload.name === "AbortError";
}
//# sourceMappingURL=Abortable.js.map